import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { HisRequest } from '../../model/his-request-classes';

@Component( {
    selector: 'his-request',
    templateUrl: './his-request.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisRequestComponent {
    @Input() request: HisRequest;
    @Output() requestChange = new EventEmitter();

    requestApprovalStatusList = ['Abgelehnt', 'Genehmigt', 'Vorläufig genehmigt', 'Storniert', 'Endgültig abgelehnt'];
    requestProcessingStatusList = ['Gestellt', 'In Bearbeitung', 'Inhaltlich falsch',
        'Doppel abgewiesen', 'Neuantrag falsch', 'Widerrufen', 'Geprüft und abgelehnt',
        'Dokumente fehlen', 'Angenommen', 'Angenommen geändert', 'Änderung fehlerhaft',
        'Zustandegekommen', 'Änderung abgewiesen', 'Zurückgezogen', 'Gekündigt', 'Abgelaufen'];
    reasonsForRejection = [{ text: 'Sonstige Gründe', id: 0 }, { text: 'Unterschrift fehlt', id: 1 },
        { text: 'Fehlende Unterlagen', id: 2 }, { text: 'Unvollständige Unterlagen', id: 3 }];

    approvalResults: string[] = [];
    processingResults: string[] = [];

    searchApproval( event: { query: string } ) {
        let query = event.query;
        this.approvalResults = this.search( query, this.requestApprovalStatusList );
    }

    searchProcessing( event: { query: string } ) {
        let query = event.query;
        this.processingResults = this.search( query, this.requestProcessingStatusList );
    }

    search( query: string, array: string[] ): string[] {
        let result: string[] = [];
        let queryInLowerCase = query.toLowerCase();

        if ( array && array.length > 0 ) {
            for ( let entry of array ) {
                if ( entry.toLowerCase().indexOf( queryInLowerCase ) > -1 ) {
                    result.push( entry );
                }
            }
        }
        return result;
    }
}
